const url = process.env.NODE_ENV == "production" ?
    "https://ecommerce-77fh.onrender.com" :
    "http://localhost:3001"


export default url